import BaseEntity from '../../BaseEntity';

export default class Product extends BaseEntity {
    public name: string;
    public subtitle: string;
    public schoolOffer: boolean;

    constructor(json: any) {
        super(json);

        this.name = json.name;
        this.subtitle = json.subtitle;
        this.schoolOffer = json.schoolOffer;
    }

    public toString(): string {
        return this.name;
    }
}
